import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { LocationsModule } from '@flyfreely-portal-ui/locations';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { ngfModule } from 'angular-file';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { KmlUploadService } from 'libs/locations/src/lib/kml-upload.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SiteDialoguesService } from './site-dialogues.service';
import { SiteEditDialogue } from './site-edit/site-edit-dialogue.component';
import { SiteList } from './site-list/site-list.component';
import { SiteLocationEditComponent } from './site-location-edit/site-location-edit.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ModalModule.forChild(),
        LoadingIndicatorModule,
        ValidationModule,
        TooltipModule,
        MatSlideToggleModule,
        FormsModule,
        FormlyModule,
        FormlyBootstrapModule,
        LocationsModule,
        EnhancedHelpModule,
        AnalyticsModule,
        ngfModule
    ],
    providers: [SiteDialoguesService, KmlUploadService],
    declarations: [SiteEditDialogue, SiteList, SiteLocationEditComponent],
    exports: [SiteList]
})
export class SitesModule {}
